import { StyleConfig } from '@chakra-ui/react';

const container: StyleConfig = {
  baseStyle: { maxW: 'container.md' },
};

export default container;
